function noAnalyticsWarning() {
  console.warn('`analytics` is not on the `window`'); // eslint-disable-line no-console
}

export const analytics = {
  track: (...args) => {
    // eslint-disable-next-line no-unused-expressions
    window.analytics ? window.analytics.track(...args) : noAnalyticsWarning();
  },
  page: (...args) => {
    // eslint-disable-next-line no-unused-expressions
    window.analytics ? window.analytics.page(...args) : noAnalyticsWarning();
  },
};
